// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__vrnbK","figure":"cover_figure__nguT5","caption":"cover_caption__vmK9W","titleBg":"cover_titleBg__7vBwg"};